import type { AdaptedWallet } from '@relayprotocol/relay-sdk'
import { adaptTronWallet } from '@relayprotocol/relay-tron-wallet-adapter'
import type { TronWeb } from 'tronweb'

export type TronAddress = `T${string}`

export type TronTxHash = string

export type TronWallet = {
  address(): Promise<TronAddress>
  vmType: 'tvm'
} & AdaptedWallet

export function getTronWallet(
  walletAddress: TronAddress,
  tronWeb: TronWeb,
): TronWallet {
  return adaptTronWallet(walletAddress, tronWeb) as TronWallet
}
